// import { Link } from "react-router-dom";
// import styled from "styled-components";
// import { IMedia } from "../../types/types";
// import { Title } from "glamorous";
import { styled } from "styled-components";
import {  IMagazinSlide } from "../../types/home_slider";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const MagazinSliderComponent = ({ ...props }) => {
  //   const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  return (
    <Row xs={1} md={2} className="g-4">
      {props.slides.map((slideRow: IMagazinSlide) => (
        <Col>

          <Card className="mb-4 shadow-sm">
          <SLink target="blank" to={`${process.env.REACT_APP_CMS}${slideRow?.attributes.pdf?.data?.attributes?.url ?? ''}`}>

            <Card.Img
              className="bd-placeholder-img card-img-top"
              width="100%"
              height="625"
              role="img"
              aria-label="Placeholder: Thumbnail"
              variant="top"
               src={`${process.env.REACT_APP_CMS}${slideRow?.attributes.Image?.data?.attributes?.url ?? ''}`}

            />
          </SLink>

            <Card.Body>
              <Card.Text>{slideRow.attributes.Title}</Card.Text>
            </Card.Body>
          </Card>

        </Col>
      ))}
    </Row>
  );
};

const SLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  flex-grow: 1; // Ensures the link takes the full space of the column for consistent styling
`;


export default MagazinSliderComponent;
